import { Gap } from '@salecycle/ui-component-library';
import { ITemplateValidationRule } from 'sections/design/template-management/entities/templates';
import { ValidationItemContainer } from '../../../../style';
import { ValidationItemBody } from './ValidationItemBody';
import { ValidationItemHeader } from './ValidationItemHeader';

interface IProps {
  validationItem: ITemplateValidationRule;
}

export const ValidationItem = ({ validationItem }: IProps) => {
  return (
    <ValidationItemContainer>
      <ValidationItemHeader validationItem={validationItem} />
      <Gap bottom={3} />
      <ValidationItemBody validationItem={validationItem} />
    </ValidationItemContainer>
  );
};
